<template lang="html">
  <section class="bottom">

    <banner-contacto v-if="showBanner"></banner-contacto>
    <banner-fp v-if="lang == 'es'"></banner-fp>

    <footer class="contenedor-enlaces">

      <div class="container row-center fww aifs">

        <article class="contenedor-logo row-start">
          <img width="143px" src="/static/img/logo-blanco.png" alt="Logo iformalia">
        </article>
        <article class="datos">

          <p class="direccion" v-html="$t('contacto.boxAdress.direccion')"></p>
          <!-- <p class="direccion">C/ Fuencarral 119 3ºB, 28010 Madrid</p> -->
          <p class="telefono"><a :href="$t('contacto.boxAdress.telTo')" @click="trackPhoneClick">{{
            $t('contacto.boxAdress.tel') }}</a></p>
          <p class="mail"><a :href="$t('contacto.boxAdress.mailto')">{{ $t('contacto.boxAdress.mail') }}</a></p>

        </article>
        <article class="rrss">

          <p v-html="$t('banner_contacto.siguenos')"></p>

          <nav class="rrss-icons row-start">
            <!--<a target="_blank" href="https://www.facebook.com/iformalia"><i class="fa fa-facebook"></i></a>-->
            <a target="_blank" href="https://www.linkedin.com/company/iformalia/about/ink"><i
                class="fa fa-linkedin"></i></a>
          </nav>

        </article>

        <article class="newsletter">
          <newsletter></newsletter>
        </article>


      </div>
      <div class="sub-footer">
        <nav class="row-between container aic h-100 enlaces">

          <div class="row-start aic h-100">
            <router-link target="_blank" :to="$t('enlaces.politica_privacidad')">{{
              $t('banner_contacto.politicaPrivacidad') }}</router-link>
            <router-link target="_blank" :to="$t('enlaces.politica_cookies')">{{ $t('banner_contacto.politicaCookies')
            }}</router-link>
            <router-link target="_blank" :to="$t('enlaces.aviso_legal')" v-if="lang == 'es'">{{
              $t('banner_contacto.avisoLegal') }}</router-link>
          </div>
          <div class="row-end h-100 aic logos">
            <a href="https://www.capterra.es/software/1061700/iformalia" target="_blank" rel="noopener noreferrer">
              <img src="/static/img/capterra-pie.png" alt="Software advise">
            </a>
            <a href="https://www.softwareadvice.com/lms/iformalia-profile/" target="_blank" rel="noopener noreferrer">
              <img src="/static/img/software-advice-pie.png" alt="Software advise" class="">
            </a>

            <a href="https://www.getapp.cl/software/2071697/iformalia " target="_blank" rel="noopener noreferrer">
              <img src="/static/img/app-logo-pie.png" alt="Software advise">
            </a>
          </div>
        </nav>
      </div>

      <div class="black-label">
        <div class="container row-between">

          <div class="row-start fww copyright">

            <img src="/static/img/certificados/certi5_1.png" alt="Veritas" class="w-100 h-100">
            <img src="/static/img/certificados/certi6_1.png" alt="Veritas" class="w-100 h-100">
            <img src="/static/img/certificados/certi7_1.png" alt="Veritas" class="w-100 h-100">
            <img src="/static/img/certificados/certi8_1.png" alt="Veritas" class="w-100 h-100">
            <img src="/static/img/certificados/certi9_1.png" alt="Veritas" class="logo-9 w-100 h-100">
            <img src="/static/img/certificados/certi10.png" alt="Veritas" class="logo-10 w-100 h-100">

          </div>
          <div>
            <p v-html="$t('banner_contacto.derechos')"></p>
          </div>


        </div>
      </div>

    </footer>

    <div class="cover-popup-carga" v-if="isLoading">

      <div class="contenedor-loading row-center">
        <img src="/static/img/loading.gif" alt="Loading">
      </div>

    </div>

  </section>
</template>

<script lang="js">

import idioma from '@/components/view-parts/footer/idioma'
import bannerContacto from '@/components/view-parts/footer/banner-contacto'
import bannerFP from '@/components/view-parts/footer/banner-fp'
import Newsletter from '@/components/view-parts/footer/newsletter'

import { mapGetters } from 'vuex';

export default {
  name: 'app-footer',
  props: [],
  mounted() {
    if (typeof gtag !== 'undefined') {
      gtag('config', 'AW-663879014/5seZCMTRq_oaEOb6x7wC', {
        phone_conversion_number: '+34 91 142 78 87',
      });
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(['isLoading']),
    ...mapGetters({
      lang: 'getLanguage'
    }),
    showBanner: function () {
      let hidden = ['/contacto', '/contact', '/contatto', '/richiedi-demo'];
      return !(hidden.some(e => e == this.$route.path));
    }
  },
  methods: {
    trackPhoneClick() {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'conversion', {
          send_to: 'AW-663879014/5seZCMTRq_oaEOb6x7wC',
          phone_conversion_number: '+34 91 142 78 87',
        });
      }
    }
  },
  components: {
    'idioma': idioma,
    'banner-contacto': bannerContacto,
    'banner-fp': bannerFP,
    'newsletter': Newsletter
  }
}
</script>

<style scoped>
.logo-9 {
  width: 59px !important
}

.logo-10 {
  width: 70px !important
}

.row-start.fww.copyright img {
  width: 70px;
  background-color: white;
  border-radius: 18px;
  margin: 0px 5px;
  max-height: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.contenedor-enlaces {
  background: #41566d;
  padding: 50px 0 0 0;
}

.contenedor-enlaces article {
  width: 25%;
  padding: 0 20px;
}

.contenedor-enlaces article:first-of-type {
  padding-left: 0;
}

.contenedor-enlaces article:last-of-type {
  padding-right: 0;
}

.datos p {
  padding-left: 25px;
  min-height: 40px;
}

.datos .direccion {
  background: url(/static/img/icon-direccion.svg) left 5px/15px no-repeat;
}

.datos .telefono {
  background: url(/static/img/icon-telefono.svg) center left/15px no-repeat;
  line-height: 40px;
}

.datos .mail {
  background: url(/static/img/icon-email.svg) center left/16px no-repeat;
  line-height: 40px;
}

.rrss-icons {
  margin-top: 10px;
}

.rrss-icons a {
  width: 25px;
  height: 25px;
  line-height: 25px;
  background: white;
  margin-right: 7px;
  display: inline-block;
  border-radius: 2px;
  padding: 0;
  text-align: center;
}

.rrss-icons a i {
  font-size: 18px;
  color: #41566d;
  height: 25px;
  line-height: 25px;
}

.black-label {
  background: #1d1d1b;
  margin-top: 20px;
  padding: 15px 0;
  position: relative;
}


.black-label:hover::before {
  transition-delay: 0;
  opacity: 1;
}

.black-label p {
  width: auto;
  margin-left: 30px;
}


nav a {
  font-size: 14px;
  color: #ececec;
  line-height: 20px;
  height: 20px;
  border-right: 1px solid #ececec;
  width: 100%;
  text-align: left;
  padding: 0 10px;
  display: inline-block;
  width: auto;
}

nav a:last-of-type {
  border: none;
  padding-right: 0;
}

.cover-popup-carga {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 50;
  background: rgba(255, 255, 255, 0.5);
}

.contenedor-loading {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}

.sub-footer {
  border-top: 1px solid white;
  padding-top: 30px;
  margin-bottom: 0;
  padding-bottom: 0;

}

.sub-footer div.logos a {
  height: auto;
  border: 0;
  margin: 0 20px;
}

.sub-footer div.logos a img {
  max-width: 100%;
}

@media screen and (max-width: 900px) {
  .black-label p {
    width: auto;
    margin-top: 10px;
  }

  .contenedor-enlaces {
    padding-top: 20px;
  }

  .contenedor-logo {
    display: none;
  }

  .contenedor-enlaces article {
    width: 50%;
    padding: 0;
    padding-right: 25px;
  }

  .contenedor-enlaces article.newsletter {
    width: 100%;
    -webkit-order: -1;
    -moz-order: -1;
    -ms-order: -1;
    -o-order: -1;
    order: -1;
    margin-bottom: 20px;
  }

  .rrss {
    order: 3;
  }

  .black-label .copyright {
    display: flex;
    margin: 10px 0px;

    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: row;
    width: 100%;
    align-items: center;
    justify-content: center;
  }

  .black-label nav {
    width: 100%;
    justify-content: center;
    -webkit-justify-content: center;
  }

  footer div.container {
    max-width: 640px;
    display: flex;
    flex-direction: column-reverse;
  }

  .sub-footer div.logos {
    margin-top: 20px;
    justify-content: center;
    width: 100%;
  }

  .sub-footer .enlaces .row-start {
    justify-content: center;
    width: 100%;
  }

}

@media screen and (max-width: 600px) {
  .contenedor-enlaces article {
    width: 100%;
  }

  footer p {
    font-size: 14px !important;
    line-height: 1.57em !important;
  }

  nav a {
    padding: 0 5px;
  }

  .black-label p {
    text-align: center;
    margin-left: 0;
    margin-bottom: 10px;
  }

  .sub-footer .enlaces .row-start a {
    font-size: 12px;
  }

  .sub-footer div.logos a {
    margin: 5px 10px 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/footer.vue